/* Asteria Elite V26: preview context belongs to the preview theme, not to language alone. */
(() => {
  'use strict';
  const u = new URL(window.location.href);
  const runtime = window.AEThemeRuntime || {};
  const themeId = String(runtime.id || window.Shopify?.theme?.id || '');
  const role = String(runtime.role || window.Shopify?.theme?.role || '').toLowerCase();
  const hashArgs = new URLSearchParams(u.hash.startsWith('#') ? u.hash.slice(1) : '');
  const activePreviewId = /^\d{8,18}$/.test(u.searchParams.get('preview_theme_id') || '') ? u.searchParams.get('preview_theme_id') : '';
  let previewId = activePreviewId;
  if (!previewId && ['unpublished', 'development', 'demo'].includes(role) && /^\d{8,18}$/.test(themeId)) previewId = themeId;
  if (activePreviewId) {
    try {
      sessionStorage.setItem('ae_v26_preview_id', activePreviewId);
      sessionStorage.setItem('ae_v26_preview_theme_id', themeId);
    } catch (_) {}
  } else if (!previewId) {
    try {
      const saved = sessionStorage.getItem('ae_v26_preview_id') || '';
      const savedTheme = sessionStorage.getItem('ae_v26_preview_theme_id') || '';
      if (/^\d{8,18}$/.test(saved) && savedTheme === themeId && role !== 'main') previewId = saved;
    } catch (_) {}
  }
  // The QA override is strictly for the unpublished theme or its preview URL.
  const inPreview = !!previewId && role !== 'main';
  const requestedCountry = (u.searchParams.get('ae_test_country') || hashArgs.get('ae_test_country') || '').toUpperCase();
  if (inPreview && /^[A-Z]{2}$/.test(requestedCountry)) {
    try { sessionStorage.setItem('ae_v26_test_country', requestedCountry); } catch (_) {}
  }
  let country = '';
  if (inPreview) {
    try { country = (sessionStorage.getItem('ae_v26_test_country') || '').toUpperCase(); } catch (_) {}
    if (!/^[A-Z]{2}$/.test(country)) country = '';
  }
  function withPreviewContext(pathOrUrl) {
    const target = new URL(pathOrUrl, window.location.origin);
    if (!inPreview || target.origin !== window.location.origin) return target;
    if (/^\/(?:cart|checkout|account|customer_authentication)(?:\/|$)/i.test(target.pathname)) return target;
    target.searchParams.set('preview_theme_id', previewId);
    if (country) target.searchParams.set('ae_test_country', country);
    return target;
  }
  const api = { previewId, country, inPreview, withPreviewContext };
  window.AEPreviewContext = api;
  function decorate(anchor) {
    if (!inPreview || !anchor || !anchor.getAttribute) return;
    const raw = anchor.getAttribute('href');
    if (!raw || raw.startsWith('#') || /^(?:mailto:|tel:|javascript:)/i.test(raw)) return;
    try {
      const abs = new URL(raw, location.origin);
      if (abs.origin !== location.origin) return;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections|pages|blogs)(?:\/|$)/i.test(abs.pathname)
          && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(abs.pathname)) return;
      const next = withPreviewContext(abs).href;
      if (next !== anchor.href) anchor.href = next;
    } catch (_) {}
  }
  if (inPreview) {
    document.addEventListener('click', e => {
      const a = e.target?.closest?.('a[href]');
      decorate(a);
    }, true);
    const update = () => document.querySelectorAll('a[href]').forEach(decorate);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
    else update();
  }
  // Server-rendered market verification. This reports the CURRENT Shopify
  // contextual country/currency rather than the requested market.
  if (inPreview && country) {
    const display = () => {
      if (document.getElementById('ae-v26-market-qa')) return;
      const badge = document.createElement('div');
      badge.id = 'ae-v26-market-qa';
      badge.setAttribute('role', 'status');
      const actual = String(runtime.country || '??').toUpperCase();
      const currency = String(runtime.currency || '??').toUpperCase();
      const ok = actual === country;
      badge.textContent = 'V26 DRAFT · Test: '+country+' · Shopify: '+actual+' / '+currency + (ok ? ' ✓' : ' ⚠ MARKET NOT SWITCHED');
      badge.style.cssText = 'position:fixed;top:0;left:0;z-index:2147483001;font:600 12px/1.3 Arial,sans-serif;color:#111;background:' + (ok ? '#d2f8d8' : '#fff0b8') + ';padding:6px 10px;border-radius:0 0 6px 0;box-shadow:0 2px 8px #0005;pointer-events:none;max-width:90vw';
      document.body.appendChild(badge);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', display);
    else display();
  }
})();
